import { GATEOFF, MANDATE } from "../../constants/common/locationFieldConstants";

/**
 * Function to get filtered city list
 *
 * @param {string} value value of input.
 * @param {Array} cityListData citylist
 * @returns {Array} filtered list of cities.
 */
export const getFilteredCitiesList = (value, cityListData, cityNameKey = "CITY_NAME") => {
  let filteredCitiesInclude = [];
  if (!value) {
    return filteredCitiesInclude;
  }
  const filteredCitiesStartsWith = cityListData?.filter((city) =>
    city?.[cityNameKey]?.toLowerCase().startsWith(value.toLowerCase()),
  );

  if (filteredCitiesStartsWith?.length === 0) {
    filteredCitiesInclude = cityListData?.filter((city) =>
      city?.[cityNameKey]?.toLowerCase().includes(value.toLowerCase()),
    );
  }
  return [...filteredCitiesStartsWith, ...filteredCitiesInclude].reduce((unique, cityObj) => {
    if (!unique.some((obj) => obj.cityId === cityObj.cityId && obj[cityNameKey] === cityObj[cityNameKey])) {
      unique.push(cityObj);
    }
    return unique;
  }, []);
};

/**
 * Return the gate config based on A/B test value.
 * @param {*} configValue
 * @returns
 */
export const getGateConfig = (configValue, cmsConfigData) => {
  let isAuto = configValue !== GATEOFF;
  let isMandate = configValue === MANDATE;
  let configObj = {
    ...cmsConfigData,
    isAutoGateEnabledOnDesktopPLP: configValue ? isAuto : cmsConfigData?.isAutoGateEnabledOnDesktopPLP,
    isAutoGateMandateOnDesktopPLP: configValue ? isMandate : cmsConfigData?.isAutoGateMandateOnDesktopPLP,
    isAutoGateEnabledOnMobilePLP: configValue ? isAuto : cmsConfigData?.isAutoGateEnabledOnMobilePLP,
    isAutoGateMandateOnMobilePLP: configValue ? isMandate : cmsConfigData?.isAutoGateMandateOnMobilePLP,
  };
  return configObj;
};

/**
 * returns the country flags for location lock
 */
export const fetchCountryFlag = (countryListData = [], catalogId) => {
  if (Array.isArray(countryListData)) {
    const entry = countryListData?.find((obj) => obj.catelogID === catalogId);
    return entry ? entry.webLogo : "/icons/location_icon_green.svg";
  }
  return "/icons/location_icon_green.svg";
};
